import React from 'react';

import { Box, Flex, Tooltip } from '@chakra-ui/react';

import { Avatar } from 'uiToolkitV1/Avatar';
import { AvatarGroup } from 'uiToolkitV1/AvatarGroup';

const ArchivedBy = ({ data }) => {
  const { archivedBy = [] } = data ?? {};
  const { displayName, profilePhoto } = archivedBy;

  return (
    <Box
      height="100%"
      sx={{
        '.chakra-avatar__group': {
          height: '100% !important',
        },
        '.chakra-avatar': {
          marginRight: '4px',
        },
      }}
    >
      <AvatarGroup>
        <Tooltip sx={{ background: '#595E6A', fontSize: '12px', color: '#ffffff' }} label={displayName}>
          <Flex>
            <Avatar name={displayName} src={profilePhoto} />
          </Flex>
        </Tooltip>
      </AvatarGroup>
    </Box>
  );
};

export { ArchivedBy };
